var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("language")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                [
                  _c("app-language-select", {
                    attrs: { label: _vm.$ct("default-language"), fancy: "" },
                    model: {
                      value: _vm.value.DefaultLanguage,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "DefaultLanguage", $$v)
                      },
                      expression: "value.DefaultLanguage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }